import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { formatINR } from "@/lib/api";
import { PageHeader, Spinner, EmptyState, Table } from "@/components/common";
import { StatusBadge } from "@/components/StatusBadge";
import { CalendarCheck } from "lucide-react";

export default function Bookings() {
  const navigate = useNavigate();
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/bookings").then((r) => setList(r.data)).catch(() => setList([])); }, []);
  if (!list) return <Spinner />;

  return (
    <div className="animate-fadeUp">
      <PageHeader title="Bookings" subtitle="Confirmed and in-progress programs" />
      {list.length === 0 ? (
        <EmptyState icon={CalendarCheck} title="No bookings yet" text="Bookings appear here once a quotation is approved." />
      ) : (
        <Table head={["Reference", "Title", "Type", "Institution", "Amount", "Payment", "Status"]}>
          {list.map((b) => (
            <tr key={b.id} data-testid={`booking-row-${b.id}`} onClick={() => navigate(`/app/bookings/${b.id}`)}
              className="cursor-pointer border-b border-border/60 last:border-0 hover:bg-background/40">
              <td className="px-4 py-3 font-mono text-xs text-primary">{b.reference}</td>
              <td className="px-4 py-3 font-medium">{b.title}</td>
              <td className="px-4 py-3 capitalize text-muted-foreground">{b.type}</td>
              <td className="px-4 py-3 text-muted-foreground">{b.institution_name}</td>
              <td className="px-4 py-3 font-mono">{formatINR(b.amount)}</td>
              <td className="px-4 py-3"><StatusBadge status={b.payment_status} /></td>
              <td className="px-4 py-3"><StatusBadge status={b.status} /></td>
            </tr>
          ))}
        </Table>
      )}
    </div>
  );
}
